import React from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "./Css/themes/base/all.css";
import "./Css/login.css";
import logo from "../logo.svg";
import "../App.css";
import axios from "../utils/axiosConfig";
import { withAuth } from "../auth/AuthContext";
import Swal from "sweetalert2";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { getBrowserTimeZone, getTimeZoneOffsetText, saveCurrentTimeZone } from "../utils/timezones";

var table;
var miStorage = window.localStorage;

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggingIn: false,
      showPassword: false,
    };

    this.login = this.login.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // Oculta sidenav antes del primer render del login
    if (typeof document !== "undefined" && !document.body.classList.contains("login-page")) {
      document.body.classList.add("login-page");
      document.documentElement.classList.add("login-page");
    }
    if (!localStorage.getItem("sw-empresa")) {
      localStorage.setItem("sw-empresa", true);
      localStorage.setItem("sw-ubicaciongps", true);
      localStorage.setItem("sw-dispositivo", true);
      localStorage.setItem("sw-ruta", true);
      localStorage.setItem("sw-ubicaciontrafico", true);
      localStorage.setItem("sw-tiempo", true);
      localStorage.setItem("sw-placa", true);
      localStorage.setItem("sw-bateria", true);
      localStorage.setItem("sw-estado", true);
      localStorage.setItem("sw-moving", true);
      localStorage.setItem("sw-locked", true);
      localStorage.setItem("sw-back", true);
      localStorage.setItem("sw-desvio", true);
      localStorage.setItem("sw-seguro", true);
      localStorage.setItem("sw-valitronics", true);
      localStorage.setItem("sw-nogps", true);
      localStorage.setItem("sw-colors-refuerzo", false);

    }
  }

  componentDidMount() {
    $("#danger-alert").hide();
    $("#menu").hide();
  }

  componentWillUnmount() {
    document.body.classList.remove("login-page");
    document.documentElement.classList.remove("login-page");
  }

  handleSubmit(event) {
    if (event?.preventDefault) event.preventDefault();
    this.login();
  }

  // METODO PARA LOGUEARSE EN EL SISTEMA
  login() {
    if (this.state.isLoggingIn) return;

    let data = {
      user: $("#user").val(),
      pass: $("#password").val(),
    };
    // console.log("Data:", data); // Verificar los datos recibidos del formulario

    const json = JSON.stringify(data);
    this.setState({ isLoggingIn: true });
    axios
      .post(process.env.REACT_APP_SERVER + "/login", json, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((res) => {
        // console.log("Login response:", res); // Verificar la respuesta del servidor
        if (res.data.success) {
          // console.log("Login successful:", res.data);
          this.props.auth.loginWithToken(res.data.token);
          localStorage.setItem("username", data.user);
          localStorage.setItem("server", res.data.entorno);
          localStorage.setItem("project", res.data.proyecto);
          localStorage.setItem("time_reload", res.data.timereload);
          localStorage.setItem("empresa", res.data.empresa);
          localStorage.setItem("logoempresa", res.data.logo);
          localStorage.setItem("diffhorario", res.data.diffhorario);
          // this.props.setUser({
          //   username: res.data.session.username,
          //   companyId: res.data.session.idempresa,
          //   server: res.data.entorno,
          // });
          localStorage.setItem("lastActivityTimeTokenCreate", new Date());
          const expirationTime = new Date().getTime() + ((60 * 60 * 1000 * res.data.TiempoSesionH) - 120000); // Calcular el tiempo de expiración
          localStorage.setItem("tokenExpiration", expirationTime); // Aquí se inicializa tokenExpiration
          localStorage.setItem("intervalRefresh", res.data.TiempoSesionH);
          const browserTimeZone = getBrowserTimeZone();
          const previousBrowserTimeZone = localStorage.getItem("browser_time_zone");
          const hasPreferredTimeZone = Boolean(localStorage.getItem("preferred_time_zone"));

          localStorage.setItem("browser_time_zone", browserTimeZone);
          localStorage.setItem("browser_time_zone_offset", getTimeZoneOffsetText(browserTimeZone) || "");

          // Primer ingreso en este navegador: usar zona del navegador por defecto, sin modal.
          if (!hasPreferredTimeZone) {
            saveCurrentTimeZone(browserTimeZone);
            sessionStorage.removeItem("show_timezone_prompt");
          } else if (previousBrowserTimeZone && previousBrowserTimeZone !== browserTimeZone) {
            // Si cambió la zona del navegador desde el último ingreso, mostrar prompt.
            sessionStorage.setItem("show_timezone_prompt", "1");
          } else {
            sessionStorage.removeItem("show_timezone_prompt");
          }

          window.location.href = "/principal";
        } else {
          this.setState({ isLoggingIn: false });
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Los datos ingresados son inválidos.",
          });
        }
      })
      .catch(() => {
        this.setState({ isLoggingIn: false });
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No fue posible iniciar sesión. Intenta de nuevo.",
        });
      });
  }





  render() {
    return (
      <div className="container-xxl">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner">
            <div className="card">
              <div className="card-body">
                <div className="app-brand justify-content-center mb-0">
                  <a href="/" className="app-brand-link">
                    <img
                      alt=""
                      className="style21"
                      src="./Cargotronics.png"
                      height="100"
                    />
                    {/* <span className="LabelLogo">INFOCARGA</span> */}
                  </a>
                </div>
                <h4 className="mb-5 text-center" style={{ fontSize: 20 }}>
                  Supply Chain Intelligence
                </h4>


                <form id="formAuthentication" className="mb-3" onSubmit={this.handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Username
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="user"
                      name="email-username"
                      placeholder="Ingresa tu usuario"
                      autoFocus
                    />
                  </div>
                  <div className="mb-3 form-password-toggle">
                    <div className="d-flex justify-content-between">
                      <label className="form-label" htmlFor="password">
                        Password
                      </label>
                    </div>
                    <div className="input-group input-group-merge">
                      <input
                        type={this.state.showPassword ? "text" : "password"}
                        id="password"
                        className="form-control"
                        name="password"
                        placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                        aria-describedby="password"
                      />
                      <button
                        className="input-group-text login-password-toggle"
                        type="button"
                        onClick={() => this.setState(({ showPassword }) => ({ showPassword: !showPassword }))}
                        aria-label={this.state.showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                        aria-pressed={this.state.showPassword}
                      >
                        {this.state.showPassword ? <FiEyeOff /> : <FiEye />}
                      </button>
                    </div>
                  </div>

                  <div className="mb-3">
                    <button
                      id="btnLogin"
                      className="btn btn-outline-secondary d-grid"
                      type="submit"
                      disabled={this.state.isLoggingIn}
                    >
                      {this.state.isLoggingIn ? (
                        <span className="login-btn-content">
                          <span
                            className="spinner-border spinner-border-sm login-btn-spinner"
                            role="status"
                            aria-hidden="true"
                          />
                          <span className="login-btn-label">Ingresando...</span>
                        </span>
                      ) : (
                        <span className="login-btn-content">
                          <span className="login-btn-label">Ingresar</span>
                        </span>
                      )}
                    </button>
                  </div>
                </form>
                {/* <div className="text-center">
                  <span className="badge bg-secondary">V.G.1</span>
                </div> */}

                {/* <p className="text-center">
                  <span>Producto realizado por </span>
                  <span>Logiseguridad Ltda</span>
                </p> */}
              </div>
            </div>
          </div>
        </div>
        {/* <button
          className="login-fab"
          type="button"
          onClick={() => {
            window.location.href = "https://cargotronics.com";
          }}
          aria-label="Ir al inicio"
        >
          <FiArrowLeft className="login-fab-icon" />
          <span className="login-fab-text">Inicio</span>
        </button> */}
      </div>
    );
  }
}

export default withAuth(Login);
